import { Navigate } from 'react-router-dom';

import { useFeatureIsEnabled } from '$components/feature-toogle/feature-is-enabled';
import { Dashboard } from '$features/dashboard';

export function DashboardPage() {
  const isDashboardEnabled = useFeatureIsEnabled('DASHBOARD_BETA');

  if (!isDashboardEnabled) {
    return <Navigate to="/devices" replace />;
  }

  return <Dashboard />;
}
